import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { AprovacaoCompraRequest } from '../../requests/compras/aprovacao-compra.request';
import { AprovacaoCompraResponse } from '../../responses/compras/compra-aprovacao.response';

@Injectable({
  providedIn: 'root',
})
export class CompraAprovacaoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'CompraAprovacao';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAprovacao(idCompra: number): Observable<AprovacaoCompraResponse> {
    return this.httpClient
      .get<AprovacaoCompraResponse>(`${this.apiUrl}/${idCompra}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** `idsUsuarioPerfil`: destinatários por perfil das automações de notificação, já
   *  expandidos (perfil -> usuários vive na API de Usuário). */
  public registrarAprovacao(idCompra: number, aprovado: boolean, justificativa?: string | null,
    idsUsuarioPerfil?: number[]): Observable<AprovacaoCompraResponse> {
    const request: AprovacaoCompraRequest = { aprovado, justificativa, idsUsuarioPerfil };
    return this.httpClient
      .post<AprovacaoCompraResponse>(`${this.apiUrl}/${idCompra}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public reverterAprovacao(idCompra: number): Observable<AprovacaoCompraResponse> {
    return this.httpClient
      .delete<AprovacaoCompraResponse>(`${this.apiUrl}/${idCompra}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
